<ng-template #Modal let-data let-ref="dialogRef">
  <form #ModalF="ngForm">
    <nb-card class="staffInfoTemplate" [nbSpinner]="info.IsLoding">
      <nb-card-header *ngIf="info.moType==1">{{ tt('common_add_addon_item', '新增附加品項') }}</nb-card-header>
      <nb-card-header *ngIf="info.moType==2">{{ tt('common_edit', '編輯') }}{{ tt('common_add_addon_item', '附加品項') }}</nb-card-header>
      <nb-card-header *ngIf="info.moType==4">{{ tt('common_view', '查看') }}{{ tt('common_add_addon_item', '附加品項') }}</nb-card-header>

      <nb-card-body>
        <div class="row rowTop">
          <div class="row mx-0 col-sm-12">
            <label class="label col-sm-12 col-form-label required">{{ tt('common_option_name', '選項名稱') }}</label>
            <input name="AttachItemName" nbInput required autocomplete="off" [(ngModel)]="att.ItemName">
          </div>
        </div>

        <div class="row rowTop">
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label required">{{ tt('common_quantity', '數量') }}</label>
            <input type="number" name="Quantity" nbInput required [(ngModel)]="att.Quantity">
          </div>

          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label required">{{ tt('common_original_price', '原價') }}</label>
            <input type="number" name="Cash" nbInput min="0" [(ngModel)]="att.Cash" required>
          </div>
        </div>

        <div class="row rowTop">
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label">{{ tt('common_erp_code', 'ERP編碼') }}</label>
            <input name="SAPProductNo" type="text" nbInput fullWidth [(ngModel)]="att.SAPProductNo" />
          </div>

          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label">{{ tt('report_mobile_barcode', '條碼') }}</label>
            <input name="Barcode" type="text" nbInput fullWidth [(ngModel)]="att.Barcode" />
          </div>
        </div>

        <div class="row rowTop">
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label">{{ tt('common_external_code', '外部編碼') }}</label>
            <input name="ExternalNo" type="text" nbInput fullWidth [(ngModel)]="att.ExternalNo" />
          </div>
        </div>

        <div *ngIf="info.moType==2" class="text-danger mt-3">PS: 修改後會連動到其他使用同選項的群組中，修改前請確認!</div>
      </nb-card-body>

      <nb-card-footer>
        <button *ngIf="this.info.moType != 4" nbButton (click)="onSave();" [disabled]="ModalF.invalid">{{ tt('common_confirm', '確定') }}</button>
        <button nbButton (click)="ref.close()">{{ tt('common_close', '關閉') }}</button>
      </nb-card-footer>
    </nb-card>
  </form>
</ng-template>
